import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Loading } from 'barnyard/components';
import BuyerInfo from '../forms/BuyerInfo';
import { zipcodeLookup } from '../actions';


class BuyerInfoFormWrapper extends Component {
  constructor(props) {
    super(props);

    _.bindAll(this, 'onZipcodeChange', 'handleSubmit');

    this.state = {
      buyerForm: props.initialValues
    };
  }

  onZipcodeChange(e, zipCode) {
    if (zipCode.length < 5) {
      return;
    }

    zipcodeLookup(zipCode, (json) => {
      this.setState({
        buyerForm: Object.assign({}, this.state.buyerForm, {
          city: json.city,
          state: json.state
        })
      });
    });
  }

  handleSubmit(values) {
    const {
      buyerUpdateAction,
      buyer,
      formType,
    } = this.props;

    let hasCompletedSignup = _.get(buyer, 'has_requisitioned_checkouts', false);

    if (formType !== 'signup') {
      hasCompletedSignup = true;
    }

    const body = Object.assign({
      has_updated_information: true,
      has_completed_signup: hasCompletedSignup
    }, values);

    // If the corporate group / purchase group
    // are not enabled, let's make sure that we are not
    // sending up data that might not matter
    if (!body.corporate_group_enabled) {
      delete body.corporate_group;
    }

    if (!body.purchase_group_enabled) {
      delete body.purchase_groups;
    }

    if (values.pims === 'other') {
      body.pims = values.pims_other;
    }

    buyerUpdateAction(body);
  }

  handleFormChange(values) {
    const {
      onFormChange
    } = this.props;

    if (onFormChange) {
      onFormChange(values);
    }
  }

  render() {
    const {
      buyerFormFieldFetches,
      buyerFormFields,
      submitText,
      formType,
      onCancel,
      disabledFields,
      hiddenFields,
      profile,
      buyer,
      corporateCompanies,
      corporateCostCenters,
      scriptsEnabled,
      showSecondaryLocationField,
      isAcquistionDateRequired,
      isCogsCompanyIdRequired,
      isCorporateLocationIdRequired,
      isDefaultCostCenterRequired,
      isOpexCompanyIdRequired,
      isRegionRequired,
      isReadOnly,
      buyerCorporateMetaOptions,
      isDivisionRequired,
      isGroupRequired,
    } = this.props;
    const { buyerForm } = this.state;

    if (!buyerFormFieldFetches.isFetched) {
      return <Loading center={true} />;
    }

    const corporateName = _.get(buyerForm, 'corporate_name') || _.get(profile, 'corporate.name');
    const purchaseGroups = _.get(buyer, 'purchase_groups') || [];


    const corporateGroupValue = _.findKey(
      _.get(buyerFormFields, 'corporate_groups'),
      corpOption => _.toLower(corpOption) === _.toLower(corporateName)
    );

    const initialValue = Object.assign({
      corporate_group_enabled: _.isNil(corporateName) ? 0 : 1,
      corporate_group: corporateGroupValue,
      purchase_group_enabled: _.isEmpty(purchaseGroups) ? 0 : 1,
      purchase_groups: purchaseGroups,
    }, buyerForm);

    return (
      <BuyerInfo
        initialValues={initialValue}
        buyerFormFields={buyerFormFields}
        submitText={submitText}
        formType={formType}
        onCancel={onCancel}
        enableReinitialize={true}
        keepDirtyOnReinitialize={true}
        onSubmit={this.handleSubmit}
        onChange={this.onFormChange}
        onZipcodeChange={this.onZipcodeChange}
        disabledFields={disabledFields}
        hiddenFields={hiddenFields}
        corporateCompanies={corporateCompanies}
        corporateCostCenters={corporateCostCenters}
        scriptsEnabled={scriptsEnabled}
        showSecondaryLocationField={showSecondaryLocationField}
        isAcquistionDateRequired={isAcquistionDateRequired}
        isCogsCompanyIdRequired={isCogsCompanyIdRequired}
        isCorporateLocationIdRequired={isCorporateLocationIdRequired}
        isDefaultCostCenterRequired={isDefaultCostCenterRequired}
        isOpexCompanyIdRequired={isOpexCompanyIdRequired}
        isRegionRequired={isRegionRequired}
        isReadOnly={isReadOnly}
        buyerCorporateMetaOptions={buyerCorporateMetaOptions}
        isDivisionRequired={isDivisionRequired}
        isGroupRequired={isGroupRequired}
      />
    );
  }
}

BuyerInfoFormWrapper.defaultProps = {
  initialValues: {},
  formType: 'signup',
  disabledFields: [],
  hiddenFields: []
};

BuyerInfoFormWrapper.propTypes = {
  buyerFormFieldFetches: PropTypes.object.isRequired,
  buyerFormFields: PropTypes.object.isRequired,
  buyerUpdateAction: PropTypes.func.isRequired,
  profile: PropTypes.object,
  buyer: PropTypes.object,
  initialValues: PropTypes.object,
  onFormChange: PropTypes.func,
  submitText: PropTypes.string,
  formType: PropTypes.string,
  onCancel: PropTypes.func,
  disabledFields: PropTypes.array,
  hiddenFields: PropTypes.array,
  corporateCompanies: PropTypes.array,
  corporateCostCenters: PropTypes.array,
  scriptsEnabled: PropTypes.bool,
  showSecondaryLocationField: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  buyerCorporateMetaOptions: PropTypes.object,
};

export default BuyerInfoFormWrapper;
